import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { TIMELINE } from '../data/mock';

const About = () => {
  return (
    <section id="about" className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div className="space-y-6">
            <div className="inline-block px-4 py-1.5 bg-[#FFEFE2] text-[#F55B26] font-semibold text-xs uppercase tracking-widest rounded-full">
              About Our Foundation
            </div>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-[#0B3B44] leading-tight">
              Inspired by crisis. Driven by <span className="text-[#F55B26]">compassion.</span>
            </h2>
            <p className="text-lg text-slate-700 leading-relaxed">
              Hello Foundation was established in April 2020, inspired by the life-changing
              impact of the Covid-19 pandemic. What started as 100 daily meals for children
              in the Tsakani township quickly grew, as we witnessed the depth of real poverty
              in our communities.
            </p>
            <p className="text-lg text-slate-700 leading-relaxed">
              During the first <strong>170 days of lockdown</strong>, we facilitated
              <strong> 75,000 meals</strong>. Since inception, we&apos;ve served over
              <strong> 1 million plates</strong>. Today, we serve <strong>600 meals daily</strong>
              &nbsp;across 6 communities in Gauteng and the Western Cape — with a mission to reach 250,000 meals per annum.
            </p>

            <div className="grid grid-cols-2 gap-3 pt-2">
              {[
                'Registered NPO in South Africa',
                'Backed by the Hello Group family',
                '100% volunteer-driven operations',
                'Transparent, secure online donations',
              ].map((item) => (
                <div key={item} className="flex items-start gap-2">
                  <CheckCircle2 className="w-5 h-5 text-[#F55B26] flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-slate-700">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="absolute left-4 top-2 bottom-2 w-0.5 bg-gradient-to-b from-[#F55B26] via-[#FFB347] to-[#0B3B44]" />
            <div className="space-y-6">
              {TIMELINE.map((t, idx) => (
                <div key={idx} className="relative pl-14">
                  <div className={`absolute left-0 top-1 w-9 h-9 rounded-full flex items-center justify-center shadow-md ${
                    t.highlight ? 'bg-[#F55B26] ring-4 ring-[#F55B26]/20' : 'bg-white border-2 border-[#F55B26]'
                  }`}>
                    <span className={`w-2.5 h-2.5 rounded-full ${t.highlight ? 'bg-white' : 'bg-[#F55B26]'}`} />
                  </div>
                  <div className={`p-5 rounded-2xl transition-all hover:shadow-md ${
                    t.highlight
                      ? 'bg-gradient-to-br from-[#F55B26] to-[#FF8A3D] text-white shadow-lg'
                      : 'bg-[#FFF7F1] border border-[#FFE4CF]'
                  }`}>
                    <div className={`text-xs font-bold uppercase tracking-widest mb-1 ${
                      t.highlight ? 'text-white/90' : 'text-[#F55B26]'
                    }`}>{t.year}</div>
                    <div className={`font-bold text-lg mb-1 ${t.highlight ? 'text-white' : 'text-[#0B3B44]'}`}>
                      {t.title}
                    </div>
                    <div className={`text-sm ${t.highlight ? 'text-white/95' : 'text-slate-600'}`}>
                      {t.desc}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
